import axios from "axios";

/**
 * Farm Productivity (Productivity Zones) API service.
 *
 * Talks only to the Node backend (base URL already includes /api/admin). The
 * backend proxies the Python crop-monitoring service, so the frontend stays
 * isolated from it. Follows the project _services convention: methods resolve
 * with the response data / reject with error.response.
 */
const BASE = "farm-productivity";

export default {
  // Generate a report (create + enqueue background generation)
  async generateReport(payload) {
    try {
      const { data } = await axios.post(`${BASE}`, payload);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  // Paginated list
  async listReports(params) {
    try {
      const { data } = await axios.get(`${BASE}`, { params });
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  // Single report detail (poll this until status !== GENERATING)
  async getReport(reportUid) {
    try {
      const { data } = await axios.get(`${BASE}/${reportUid}`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  // Guide content (steps live in the frontend/i18n)
  async getGuide() {
    try {
      const { data } = await axios.get(`${BASE}/guide`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async deleteReport(reportUid) {
    try {
      const { data } = await axios.delete(`${BASE}/${reportUid}`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async submitFeedback(reportUid, payload) {
    try {
      const { data } = await axios.post(`${BASE}/${reportUid}/feedback`, payload);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async getFeedback(reportUid) {
    try {
      const { data } = await axios.get(`${BASE}/${reportUid}/feedback`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  // Returns a PDF blob
  async downloadPdf(reportUid) {
    try {
      const res = await axios.post(
        `${BASE}/${reportUid}/download-pdf`,
        {},
        { responseType: "blob" }
      );
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },
};
